<div class="home-page-container">
  <div class="tab-set-container">
    <div class="tab-content-container animate-fade-in">
      <ul class="sm-list-disc sm-pl-legacy-9.6">
        <li class="menu-item">
          <a i18n class="menu-link" routerLink="tag-groups" [routerLinkActive]="['selected']"
            >Project Photo Tags</a
          >
        </li>
        <li class="menu-item">
          <a i18n class="menu-link" routerLink="alignment" [routerLinkActive]="['selected']"
            >Project Alignment</a
          >
        </li>
      </ul>
    </div>
  </div>
  <div class="home-page-content-container">
    <div class="home-page-content-container-wp animate-fade-in">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
